import React, { useState } from "react";
import PropTypes from "prop-types";

type CollapseContextType = {
  collapseRows: boolean;
  setCollapseRows: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CollapseContext = React.createContext<
  CollapseContextType | undefined
>(undefined);

type CollapseContextProps = {
  children: React.ReactNode;
};

export const CollapseProvider = ({
  children,
}: CollapseContextProps): JSX.Element => {
  const [collapseRows, setCollapseRows] = useState(true);

  return (
    <CollapseContext.Provider value={{ collapseRows, setCollapseRows }}>
      {children}
    </CollapseContext.Provider>
  );
};

CollapseProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

// This context may not exist for every row, therefore it is optional
export const useCollapse = (): CollapseContextType => {
  const context = React.useContext(CollapseContext);
  if (context === undefined) {
    return {
      collapseRows: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setCollapseRows: (() => {}) as React.Dispatch<
        React.SetStateAction<boolean>
      >,
    };
  }

  return context;
};
